import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

export function useIsDeveloper(): boolean {
  const { token } = useAuth();
  const [developer, setDeveloper] = useState(false);

  useEffect(() => {
    if (!token) { setDeveloper(false); return; }
    api<{ developer: boolean }>('/studio/me', { token }).then((m) => setDeveloper(m.developer)).catch(() => setDeveloper(false));
  }, [token]);

  return developer;
}
